import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const useLocalStore = create(
    persist(
        (set, ) => ({
            hmsTablePageSize: 50,
            ORGANIZATION_ID: null,

            setHmsTablePageSize: (pageSize) => {
                set({
                    hmsTablePageSize: pageSize,
                });
            },
            setOrganizationId: (organizationId) => {
                set({
                    ORGANIZATION_ID: organizationId,
                });
            },
            
        }),
        {
            name: 'globalStore-persistentItems',
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => {
                const include = [
                    'hmsTablePageSize',
                    'ORGANIZATION_ID'
                ]
                return Object.fromEntries(Object.entries(state).filter(([key]) => include.includes(key)));
            },
        }
    ),
);

export default useLocalStore;